import "dayjs/locale/ja";
import { useSelector } from "react-redux";
import { RootState } from "../../store/types";
import SerialBooking from "../Customer/SerialBooking";

const CustomerHome = () => {
    const { loggedInUser } = useSelector((state: RootState) => state.global);
    
    return (<>
        <SerialBooking />
    </>
    );
};

export default CustomerHome;
